import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { bootLocale } from './i18n';
import App from './App';
import posthog from 'posthog-js';
import { shouldCountStats } from './utils/shouldCountStats';

bootLocale();

// Live room join codes must never reach third parties (privacy constraint —
// same reason the Cloudflare beacon leak is being fixed separately). Autocapture
// sends URLs like /join/A1B2C, so scrub the code from every string property
// before any event leaves the browser.
const JOIN_CODE_PATTERN = /\/(?:join|tv)\/[^/?#\s]+/gi;

const scrubJoinCodes = (value) => {
  if (typeof value === 'string') {
    return value.replace(JOIN_CODE_PATTERN, '/join/REDACTED');
  }
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    for (const key of Object.keys(value)) {
      value[key] = scrubJoinCodes(value[key]);
    }
  }
  return value;
};

// Key is only present in production builds (.env.production) or a local .env.
// Also skip localhost, Firebase preview hosts, and ?test=1 — same helper
// that gates every RTDB stats counter write. Player names are not known
// at boot; zz-test* names still skip the counter increments later.
if (process.env.REACT_APP_POSTHOG_KEY && shouldCountStats()) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    defaults: '2026-05-30',
    // Cookieless: no cookies, no localStorage (matches the cookieless
    // Cloudflare beacon posture). Anonymous ids reset per page load, but
    // App.jsx calls posthog.identify(firebaseUid) on every load, so real
    // users stay deduplicated by their stable anonymous auth UID.
    persistence: 'memory',
    before_send: (event) => {
      if (!event) return event;
      scrubJoinCodes(event.properties);
      scrubJoinCodes(event.$set);
      scrubJoinCodes(event.$set_once);
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 